export default "__VITE_ASSET__CI5EigIv__"